<template>
    <div class="template" v-if="allBetEvent  && allBetEvent.od">
      <div v-for="btype in btypes" data-template="template4" class="wrap-template template4" v-if="allBetEvent.od[plytyp] && allBetEvent.od[plytyp][btype]">
        <div class="vrow items-center template-title is_fold" style="width:100%">
          <div class="play-name col" @click="showLeg()">
            <span class="ellipsis">{{ getTitleCaption() }}</span>
          </div>
          <div style="width: 37px;" @click="setToTop($event)">
            <span class="set_top" style="display: none;">
              <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
            </span>
          </div>
        </div>
        <template>
          <div :class="'row_'+allBetEvent.eveid">
            <div class="handicap-sub-title" :class="'body_EG_'+allBetEvent.eveid">
              <!-- A -->
              <div class="flex-1 overflow-hidden part-left">
                <div class="handicap">
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">0-0</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od00'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod00" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">0-1</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od01'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod01" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">0-2</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od02'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod02" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">0-3</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od03'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod03" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">0-4</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od04'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod04" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">0-5</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od05'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod05" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">0-6</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od06'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod06" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">0-7</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od07'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod07" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">0-8</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od08'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod08" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">0-9</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od09'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod09" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">1-0</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od10'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod10" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">1-1</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od11'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod11" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">1-2</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od12'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod12" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">1-3</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od13'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod13" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">1-4</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od14'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod14" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">1-5</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od15'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod15" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">1-6</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od16'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod16" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">1-7</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od17'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod17" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">1-8</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od18'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod18" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">1-9</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od19'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod19" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">2-0</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od20'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod20" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">2-1</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od21'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod21" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">2-2</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od22'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod22" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">2-3</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od23'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod23" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">2-4</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od24'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod24" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Draw -->
              <div class="flex-1 overflow-hidden part-middle">
                <div class="handicap">
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">2-5</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od25'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod25" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">2-6</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od26'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod26" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">2-7</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od27'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod27" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">2-8</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od28'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod28" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">2-9</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od29'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod29" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">3-0</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od30'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod30" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">3-1</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od31'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod31" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">3-2</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od32'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod32" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">3-3</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od33'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod33" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">3-4</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od34'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod34" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">3-5</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od35'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod35" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">3-6</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od36'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod36" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">3-7</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od37'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod37" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">3-8</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od38'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod38" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">3-9</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od39'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod39" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">4-0</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od40'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod40" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">4-1</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od41'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod41" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">4-2</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od42'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod42" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">4-3</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od43'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod43" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">4-4</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od44'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod44" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">4-5</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od45'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod45" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">4-6</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od46'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod46" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">4-7</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od47'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod47" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">4-8</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od48'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod48" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">4-9</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od49'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod49" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Draw -->
              <div class="flex-1 overflow-hidden part-middle_eg">
                <div class="handicap">
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">5-0</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od50'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod50" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">5-1</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od51'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod51" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">5-2</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od52'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod52" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">5-3</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od53'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod53" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">5-4</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od54'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod54" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">5-5</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od55'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod55" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">5-6</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od56'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod56" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">5-7</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od57'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod57" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">5-8</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od58'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod58" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">5-9</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od59'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod59" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">6-0</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od60'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod60" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">6-1</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od61'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod61" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">6-2</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od62'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod62" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">6-3</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od63'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod63" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">6-4</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od64'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod64" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">6-5</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od65'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod65" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">6-6</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od66'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod66" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">6-7</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od67'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod67" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">6-8</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od68'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod68" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">6-9</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od69'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod69" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">7-0</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od70'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod70" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">7-1</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od71'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod71" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">7-2</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od72'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod72" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">7-3</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od73'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod73" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">7-4</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od74'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod74" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- B -->
              <div class="flex-1 overflow-hidden part-right">
                <div class="handicap">
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">7-5</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od75'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod75" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">7-6</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od76'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod76" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">7-7</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od77'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod77" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">7-8</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od78'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod78" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">7-9</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od79'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod79" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">8-0</span>
                            </div>
                          </div>
                        </div>
                        <oddEdg :event="newAllBetEvent" :score="'od80'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod23" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">8-1</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od81'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod81" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">8-2</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od82'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod82" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">8-3</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od83'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod83" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">8-4</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od84'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod84" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">8-5</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od85'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod85" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">8-6</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od86'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod86" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">8-7</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od87'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod87" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">8-8</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od88'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod88" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">8-9</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od89'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod89" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">9-0</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od90'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod90" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">9-1</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od91'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod91" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">9-2</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od92'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod92" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">9-3</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od93'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod93" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">9-4</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od94'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod94" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">9-5</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od95'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod95" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">9-6</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od96'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod96" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">9-7</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od97'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod97" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">9-8</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od98'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod98" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="bet-ellipsis ellipsis">
                              <span class="bet_handicap yb-family-odds">9-9</span>
                            </div>
                          </div>
                        </div>
                            <oddEdg :event="newAllBetEvent" :score="'od99'" :plyType="plytyp" :betType="btype" :decimalNumber="1" ref="teamod99" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
              <div class="box_innbet_btn" @click="showMore(allBetEvent.eveid)">
                  <div id="pd_show_more_4861319_4987282" class="btn_innbet_more" :data-less="sportAllBetLang['ALL_BET.LBL_VIEW_LESS']" :data-more="sportAllBetLang['ALL_BET.LBL_VIEW_MORE']">
                    <i class="icon-arrow q-icon c-icon"><svg><use xlink:href="#icon_toparr"></use></svg></i>
                  </div>
              </div>
          </div>
        </template>
      </div>
    </div>
  </template>
  
  <script>
  import {
    mapGetters
  } from 'vuex'
  import OddComponents from '../../../components/odd'
  import HandicapComponents from '../../../components/handicap'
  
  import allBetMixin from '../../../mixins/allBet'
  import oddEdg from '../../../components/odd-edg'
  
  export default {
    mixins: [allBetMixin],
    props: {
      allBetEvent: null,
      plytyp: null,
      selectMarket: null,
      removeMarket: null,
      rbinfo: null,
      myMarket: {
        type: Boolean,
        default: false
      },
      isSpecial: {
        type: Boolean,
        default: false
      },
      mode:null
    },
    data() {
      return {
        btypes: [allBetMixin.data().edgBetType],
        show: true,
      }
    },
    computed: {
      ...mapGetters([
        'foldopenAllBet',
        'foldopenFirstEvent'
      ]),
      newAllBetEvent() {
        // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
        return this.allBetEvent
      },
    },
    watch: {
      foldopenAllBet() {
        if(this.mode=='ab'){
          this.show = (this.$store.getters.foldopenAllBet) ? true : false;
        }
      },
      foldopenFirstEvent() {
        if(this.mode!='ab'){
          this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
        }
      }
    },
    methods: {
      getTitleCaption() {
        var a = 'FT'
        var b = ''
        if (this.plytyp == this.firstHtPlyType) {
          a = '1H'
        }
  
        // if (this.bettype == this.hdpBetType) {
        // b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_CS']
        b = this.sportAllBetLang['ALL_BET.LBL_EG']
        // } else if (this.bettype == this.bttsBetType) {
        //   b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_BTTS']
        // }
  
        // RB score
        // if (this.newAllBetEvent.event_rb == 1) {
        //   b += ' (' + this.newAllBetEvent.rbinfo.scoa + '-' + this.newAllBetEvent.rbinfo.scob + ')'
        // }
        return b
      },
      showLeg() {
        this.show = (!this.show) ? true : false;
      },
      setToTop(e) {
        this.$parent.setToTop(e);
      },
      addToMyMarket(plytyp, csBetType) {
        if (this.selectMarket)
          this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial)
      },
      removeFromMyMarket(plytyp, csBetType) {
        if (this.removeMarket)
          this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial)
      },
      showMore(eveid){
          var on = ''
          on = $('.body_EG_'+eveid).hasClass('on')

          if(on){
              $('.body_EG_'+eveid).removeClass('on')
              $('.row_'+eveid).removeClass('open')
          }else{
              $('.body_EG_'+eveid).addClass('on')
              $('.row_'+eveid).addClass('open')
          }
          $('#AllBet'+this.mode).getNiceScroll().resize()
      },
    },
    mounted(){
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }else{
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    },
  }
  </script>
  


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/all-bet-eg.vue